// extracted by css-extract-rspack-plugin
export default {"imageContainer":"ContentfulBackgroundImage-module__imageContainer__nn_BXQh","expandFalse":"ContentfulBackgroundImage-module__expandFalse__Njtref6"};